// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type LiabilitiesStepImportMutationVariables = Types.Exact<{
  inputs: Array<Types.AugmentedCreateLiabilityInput> | Types.AugmentedCreateLiabilityInput;
  updateEntities: Array<Types.AugmentedUpdateEntityInput> | Types.AugmentedUpdateEntityInput;
}>;


export type LiabilitiesStepImportMutation = { __typename?: 'Mutation', createLiabilities: Array<{ __typename?: 'Liability', id: string }>, updateEntities: Array<{ __typename?: 'Entity', id: string } | null> };

export const Operations = {
  Mutation: {
    LiabilitiesStepImport: 'LiabilitiesStepImport' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const LiabilitiesStepImportDocument = gql`
    mutation LiabilitiesStepImport($inputs: [AugmentedCreateLiabilityInput!]!, $updateEntities: [AugmentedUpdateEntityInput!]!) {
  createLiabilities(input: $inputs) {
    id
  }
  updateEntities(input: $updateEntities) {
    id
  }
}
    `;
export type LiabilitiesStepImportMutationFn = Apollo.MutationFunction<LiabilitiesStepImportMutation, LiabilitiesStepImportMutationVariables>;

/**
 * __useLiabilitiesStepImportMutation__
 *
 * To run a mutation, you first call `useLiabilitiesStepImportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLiabilitiesStepImportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [liabilitiesStepImportMutation, { data, loading, error }] = useLiabilitiesStepImportMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *      updateEntities: // value for 'updateEntities'
 *   },
 * });
 */
export function useLiabilitiesStepImportMutation(baseOptions?: Apollo.MutationHookOptions<LiabilitiesStepImportMutation, LiabilitiesStepImportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LiabilitiesStepImportMutation, LiabilitiesStepImportMutationVariables>(LiabilitiesStepImportDocument, options);
      }
export type LiabilitiesStepImportMutationHookResult = ReturnType<typeof useLiabilitiesStepImportMutation>;
export type LiabilitiesStepImportMutationResult = Apollo.MutationResult<LiabilitiesStepImportMutation>;
export type LiabilitiesStepImportMutationOptions = Apollo.BaseMutationOptions<LiabilitiesStepImportMutation, LiabilitiesStepImportMutationVariables>;